// Implements: F-IDN-026
/**
 * One leader per team (P3-3): the server refuses a lead invitation with `409` and names why in
 * `details` (`{field: "team_role", reason: "lead_taken" | "lead_pending"}`). The invite dialog says
 * each reason in its own Spanish line instead of the server's wording (owner 2026-10-18, option B).
 */

import type { ErrorDetails } from "../../../types/errors";

export type LeadRefusalKey = "organization.invite.leadTaken" | "organization.invite.leadPending";

const LEAD_REFUSALS: Readonly<Record<string, LeadRefusalKey>> = {
  lead_taken: "organization.invite.leadTaken",
  lead_pending: "organization.invite.leadPending",
};

/** The dictionary key of a lead refusal, or `null` for any other refusal. */
export function leadRefusalKey(details: ErrorDetails | null): LeadRefusalKey | null {
  if (details?.field !== "team_role") return null;
  return Object.hasOwn(LEAD_REFUSALS, details.reason) ? (LEAD_REFUSALS[details.reason] ?? null) : null;
}

/**
 * Owner 2026-10-26: a suspended organization takes no new person. The server says so with a `409`
 * whose `details` name `{field: "organization_id", reason: "organization_suspended"}`. The link
 * works again once the organization is reactivated, so the page keeps the form and shows the
 * server's sentence verbatim instead of calling the link dead.
 */
export function suspendedOrganizationRefusal(error: { readonly status: number; readonly details: ErrorDetails | null }): boolean {
  return (
    error.status === 409 && error.details?.field === "organization_id" && error.details.reason === "organization_suspended"
  );
}
